export default function useTeamCodes() {
  const teamCodes = {
    Georgetown: 'GTN',
    Charleston: 'COC',
    'Santa Barbara City': 'SBC',
    Eckerd: 'ECK',
    Cornell: 'COR',
    'UC Santa Barbara': 'UCSB',
    'Boston University': 'BU',
    'Kings Point': 'KP',
    Jacksonville: 'JAX',
    Fordham: 'FRD',
    'Roger Williams': 'RW',
    Pennsylvania: 'UPN',
    Navy: 'NA',
    Tufts: 'TUF',
    'Southern Cal': 'USC',
    'Oregon State': 'ORST',
    'Cal Poly': 'SLO',
    'UC Los Angeles': 'UCLA',
    'Cal Maritime': 'CMA',
    'Santa Clara': 'SCU',
    'CSU Long Beach': 'CSLB',
    Washington: 'UW',
    'Western Washington': 'WWU',
    Berkeley: 'CAL',
    Northwestern: 'NWU',
    'Texas A&M': 'TAMU',
    'UC Irvine': 'UCI',
    'UC San Diego': 'UCSD',
    'UC Santa Cruz': 'UCSC',
    'UW Milwaukee': 'UWM',
    Wisconsin: 'WIS',
    'Georgia Tech': 'GT',
    Tulane: 'TUL',
    Marquette: 'MRQ',
    Texas: 'UT',
    'Oklahoma State': 'OKS',
    'Texas A&M C. Christ': 'TAMCC',
    'Connecticut College': 'CC',
    Brown: 'BR',
    Vermont: 'UVM',
    'Old Dominion': 'ODU',
    'Rhode Island': 'URI',
    'NY Maritime': 'NYM',
    Virginia: 'UVA',
    'Christopher Newport': 'CNU',
    Florida: 'FLA',
    'Salve Regina': 'SR',
    'U South Carolina': 'SC',
    'Mass Maritime': 'MSM',
    'Coast Guard': 'CGA',
    'Boston College': 'BC',
    Yale: 'YAL',
    Harvard: 'HAR',
    'George Washington': 'GWU',
    "St. Mary's": 'SMC',
    'Hobart & William': 'HWS',
    'South Florida': 'USF',
    MIT: 'MIT',
    Dartmouth: 'DART',
    Bowdoin: 'BOW',
    Hampton: 'HU',
    'Westmont College': 'WEST',
    'UC Davis': 'UCD',
    'British Columbia': 'UBC',
    Oregon: 'OR',
    'Lewis & Clark': 'LEW',
    'Texas A&M Galveston': 'TAMUG',
    Rice: 'RICE',
    Bentley: 'BENT',
    McGill: 'MCG',
    Northeastern: 'NU',
    Middlebury: 'MID',
    'New Hampshire': 'UNH',
    Brandeis: 'BDS',
    'U New England': 'UNE',
    'Johnson and Wales': 'JW',
    Fairfield: 'FAR',
    Wesleyan: 'WES',
    'Sacred Heart': 'SH',
    'U. Connecticut': 'UCONN',
    Victoria: 'VIC',
    Princeton: 'PRN',
    Stevens: 'STV',
    'Virginia Tech': 'VT',
    "Queen's": 'QU',
    'Worcester Polytech': 'WPI',
    Duke: 'DUK',
    'Central Oklahoma': 'UCO',
    Stanford: 'STAN',
    'Washington College': 'WAC',
    'North Carolina State': 'NCS',
    'U. Miami': 'MIA',
    Michigan: 'MICH',
    'U. Rochester': 'ROC',
    Maryland: 'MD',
    Columbia: 'COL',
    Drexel: 'DRX',
    'Loyola College': 'LOY',
    'Ocean County': 'OCN',
    Delaware: 'DEL',
    'Channel Islands': 'CSUCI',
    'Arizona State': 'ASU',
    Bates: 'BAT',
    Clemson: 'CLE',
    'Florida State': 'FSU',
    'Stony Brook': 'SBU',
    'U. Mass/ Amherst': 'UMASS',
    Army: 'AR',
    Syracuse: 'SYR',
    Gannon: 'GU',
    Colgate: 'CLG',
    'Royal Military': 'RMC',
    'Webb Institute': 'WEB',
    'College Sailing': 'ICSA',
    Dalhousie: 'DAL',
    Ottawa: 'OTW',
    'U Toronto': 'TOR',
    'Penn State': 'PSU',
    'Grand Valley State': 'GVS',
    Hope: 'HOP',
    'Michigan Tech': 'MTU',
    'Michigan State': 'MSU',
    'Western Michigan': 'WMU',
    'Northern Michigan': 'NMU',
    'Ohio State': 'OSU',
    Villanova: 'VIL',
    Monmouth: 'MON',
    'William and Mary': 'WM',
    Minnesota: 'UMN',
    'Lake Forest': 'LFC',
    'Notre Dame': 'ND',
    'New Orleans': 'UNO',
    Kansas: 'KU',
    Illinois: 'ILL',
    Chicago: 'CHI',
    Rutgers: 'RUT',
    'Maryland/Baltimore': 'MBC',
    American: 'AU',
    "St. John's": 'SJC',
    'Catholic U America': 'CUOA',
    Buffalo: 'UB',
    'Maine Maritime': 'MMA',
    'Emmanuel College': 'EMCO',
    Providence: 'PC',
    Rollins: 'ROL',
    Georgia: 'GA',
    Citadel: 'CIT',
    Tennessee: 'UTN',
    Auburn: 'AUB',
    Denison: 'DEN',
    Ohio: 'OU',
    Toledo: 'TOL',
    'Miami University': 'MUO',
    'UMass Dartmouth': 'UMD',
    Iowa: 'IOWA',
    'UNC Wilmington': 'UNCW',
    'Wentworth Institute': 'WIT',
    Hawaii: 'UH',
    'Washington U': 'WUN',
    'U Pittsburgh': 'PITT',
    Lawrence: 'LAWU',
    Salisbury: 'SSU',
    'Portland State': 'PS',
    'Monterey Bay': 'CSUM',
    'Illinois (Chicago)': '0',
    'Iowa State': 'ISU',
    Indiana: 'IU',
    Davidson: 'DAV',
    'New College': 'NC',
    'San Diego State': 'SDSU',
    Wellesley: 'WEL',
    'North Texas': 'UNT',
    'Puget Sound': 'UPS',
    Amherst: 'AMH',
    Williams: 'WIL',
    Hillsdale: 'HILL',
    Rochester: 'RIT',
    'North Carolina': 'UNC',
    Hamilton: 'HMT',
    Purdue: 'PUR',
    Loyola: 'LU',
    Vanderbilt: 'VAN',
    'John Carroll': 'JCU',
    'U Nebraska': 'UNL',
    'North Florida': 'UNF',
    'U Maine': 'ume',
    Mercyhurst: 'MU',
    'Penn State Behrend': 'PSB',
    'Indiana U Pennsylvan': 'IUP',
    'U.  Mass/ Boston': 'UMAB',
    'Landing School': 'LAN',
    Colorado: 'UCB',
    'Hosei Univerisity': 'HOS',
    'East Carolina': 'ECU',
    'Wake Forest': 'WFU',
    'Texas Tech': 'TTU',
    Baylor: 'BAY',
    'Baldwin-Wallace': 'BWU',
    "Saint Mary's College": 'stmc',
    'Embry-Riddle': 'EMB',
    'Palm Beach Atlantic': 'PBAU',
    'Georgia Southern': 'GSU',
    'U of Central Florida': 'UCF',
    Olin: 'OLIN',
    'Texas Christian': 'TCU',
    'Florida Tech': 'FIT',
    'Saint Thomas': 'STT',
    'Saginaw Valley': 'SVSU',
    'Florida Gulf Coast': 'FGCU',
    Cincinnati: 'UCIN',
    'Coastal Georgia': 'ccga',
    'Cleveland State': 'CLSU',
    Oklahoma: 'UOK',
    'Case Western': 'CWR',
    Sewanee: 'SEW',
    Gonzaga: 'ZAGS',
    'Cal Poly Maritime': 'CMA',
    'Louisiana Tech': 'LTU',
    Babson: 'BAB',
    Colby: 'CBY',
    'Ole Miss': 'MISS',
  }
  return teamCodes
}
